import {
	Component,
	Input,
	Output,
	EventEmitter, OnInit
} from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { ModalButtonModel } from '../modal/models/modal-button.model';

export enum PANEL_CLASS_COLOR {
	PRIMARY = 'primary',
	SECONDARY = 'secondary',
	WARNING = 'warning',
	SUCCESS = 'success',
	DANGER = 'danger',
	INFO = 'info',
	LIGHT = 'light',
	DARK = 'dark',
	DEFAULT = 'default'
}

@Component({
	selector: 'cv-panel',
	animations: [
		trigger('panelExpation', [
			state('isOpen', style({ height: '*', visibility: 'visible' })),
			state('isClose', style({ height: '0px', visibility: 'hidden' })),
			transition('isOpen <=> isClose', animate('300ms')),
		]),
		trigger('indicatorMove', [
			state('isOpen', style({ marginTop: '5px', transform: 'rotate(180deg)' })),
			state('isClose', style({ marginBottom: '3px', transform: 'rotate(0deg)' })),
			transition('isOpen <=> isClose', animate('300ms')),
		])
	],
	templateUrl: 'panel.component.html',
	styleUrls: ['./collapse.component.scss']
})

export class PanelComponent {

	@Input() defaultOpen: boolean;
	/**
	 * @public title of the panel
	 */
	@Input() title: string;
	/**
	 * Customizable class color for the panel
	 */
	@Input() class: PANEL_CLASS_COLOR | string;
	/**
	 * @public toggle event
	 */
	@Output() toggle: EventEmitter<any> = new EventEmitter<any>();
	/**
	 *
	 */
	@Output() expand: EventEmitter<any> = new EventEmitter<any>();
	/**
	 * Set of action buttons to be placed on the header left side of the panel.
	 */
	@Input() leftButtons: Array<ModalButtonModel>;
	/**
	 * Set of action buttons to be placed on the header right side of the panel.
	 */
	@Input() rightButtons: Array<ModalButtonModel>;
	/**
	 * Determines if expand icon will be shown.
	 */
	@Input() isExpandable: boolean;
	// indicates is the panel is open or close and determine the animation flow
	state: string;
	_active: boolean;
	isExpanded: boolean;
	textClass: 'primary' | 'secondary' | 'warning' | 'success' | 'danger' | 'info' | 'light' | 'dark' | 'default';

	constructor() {
		this.leftButtons = [];
		this.rightButtons = [];
	}

	get active(): boolean {
		return this._active;
	}

	/**
	 * @public get the active panel to show and set the state of it 'close' or 'open'
	 */
	@Input()
	set active(value: boolean) {
		this._active = value;
		this.state = this._active ? 'isOpen' : 'isClose';
	}

	/**
	 * Returns the correct text color class to apply.
	 */
	getTextClass(): string {
		if (this.class
			&& this.class !== 'light'
			&& this.class !== 'default') {
			return 'text-light';
		}
		return '';
	}

	/**
	 * togglePanel
	 * * function that emits the toggle event and set the active panel
	 */
	togglePanel($event: any): void {
		if (!$event.target || $event.target.closest('.header-action-button') === null) {
			this.active = !this.active;
			this.toggle.emit(!this.active);
		}
	}

	/**
	 * On expand button emit the event.
	 */
	onExpand(): void {
		this.isExpanded = !this.isExpanded;
		this.expand.emit(this.isExpanded);
		// if it's collapsed, expand it as well
		if (this.active === false) {
			this.active = true;
			this.toggle.emit(!this.active);
		}
	}

	/**
	 * On action button click
	 * @param $event
	 */
	onButtonClick($event: any, actionButton: ModalButtonModel): void {
		if (actionButton.loading) {
			setTimeout(() => {
				actionButton.action();
			}, 200);
		} else {
			actionButton.action();
		}
	}
}
